import React from 'react';
import {
  ControlForm,
  StyledSelect,
  HelperTextForm,
  DropdownLabelText,
} from 'components/Ui/styled';
import { Controller } from 'react-hook-form';
import MenuItem from '@mui/material/MenuItem';

const FormInputDropdown = (props) => {
  const {
    name,
    control,
    label,
    options = [],
    multiple,
    renderValue,
    defaultValue,
    errors,
    helperText,
    disabled,
    readOnly,
    menuProps,
  } = props || {};

  const generateSingleOptions = () => {
    return options?.map((item, index) => {
      return (
        <MenuItem key={index} value={item.id}>
          {item.value}
        </MenuItem>
      );
    });
  };

  return (
    <ControlForm variant="standard">
      <DropdownLabelText primary={errors ? 'true' : undefined}>
        {label}
      </DropdownLabelText>
      <Controller
        render={({ field: { onChange, value } }) => (
          <StyledSelect
            MenuProps={menuProps}
            labelId="demo-simple-select-standard-label"
            id="demo-simple-select-standard"
            defaultValue={defaultValue}
            onChange={onChange}
            value={value == null ? (multiple ? [] : '') : value}
            multiple={multiple}
            renderValue={renderValue}
            error={errors}
            disabled={disabled}
            inputProps={{ readOnly: readOnly }}
          >
            {generateSingleOptions()}
          </StyledSelect>
        )}
        control={control}
        name={name}
      />
      <HelperTextForm>{helperText}</HelperTextForm>
    </ControlForm>
  );
};

export default FormInputDropdown;
